var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnerAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1C1.5 0.723857 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723857 0.5 1L1.5 1ZM10.3536 11.3536C10.5488 11.1583 10.5488 10.8417 10.3536 10.6464L7.17157 7.46447C6.97631 7.2692 6.65973 7.2692 6.46447 7.46447C6.2692 7.65973 6.2692 7.97631 6.46447 8.17157L9.29289 11L6.46447 13.8284C6.2692 14.0237 6.2692 14.3403 6.46447 14.5355C6.65973 14.7308 6.97631 14.7308 7.17157 14.5355L10.3536 11.3536ZM0.5 1L0.5 7L1.5 7L1.5 1L0.5 1ZM5 11.5L10 11.5L10 10.5L5 10.5L5 11.5ZM0.5 7C0.499999 9.48528 2.51472 11.5 5 11.5L5 10.5C3.067 10.5 1.5 8.933 1.5 7L0.5 7Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnerAccount);
export default __webpack_public_path__ + "static/media/inner_account.edbc90d8b870d17f2639f1c3aadd003c.svg";
export { ForwardRef as ReactComponent };